<template>
    <div class="row">
        <Main class="col-md-12"></Main>
    </div>
</template>
<script type="text/javascript">
    import Main from '@/components/main_page/sub_components/appsview_main.vue'
    import {mapActions} from 'vuex'

    export default {
        components: {
            Main
        },
        methods: {
            ...mapActions({
                change_top_content: 'main/change_top_content',
                change_index_content: 'main/change_index_content',
                change_dashboard_content: 'main/change_dashboard_content',
                change_main_view: 'main/change_main_view'
            })
        },
        mounted: function () {
            this.change_index_content()
        }
    }

</script>
<style type="text/css" scoped>

</style>
